// https://lincolnprofilev9.cms.dealer.com/lincoln-aviator-phev.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						page: {
							pageName:
								'research models:why buy:lincoln aviator phev',
							siteSection: 'research models',
							hierarchy: 'research models:why buy',
							pageNameNoVehicle: 'research models:why buy'
						},
						onclick: {
							onclick:
								'research models:why buy:content:photo click',
							onclickLinkName:
								'research models:why buy:content:action'
						},
						vehicle: {
							modelYear: '2023',
							nameplate: 'lincoln aviator phev'
						}
					}
				})
			},
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						[
							'Scrolled to next photo',
							'Scrolled to previous photo'
						].includes(result) && widgetName === 'ws-media-viewer'
					);
				},
				payload: ({ eventData }) => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: `hybrid ev:action:photo scroll:${
								eventData?.result.includes('next')
									? 'right'
									: 'left'
							}`,
							onclickLinkName: 'hybrid ev:content:action'
						}
					}
				})
			}
		]
	}
};
